export default __webpack_public_path__ + "static/media/felkialto.28eb9ecd.svg";